// extracted by mini-css-extract-plugin
export default {"root":"Avatar_root__drScV","icon":"Avatar_icon__1eyCc","verified":"Avatar_verified__sES-m","image":"Avatar_image__UHulV","badge":"Avatar_badge__o++Hx"};